export enum WidgetDisplay {
    Doughnut = 1,
    Single = 2,
    Table = 3,
    Line = 4,
    List = 5,
}
